import { useFeatureFlag } from '@order/LaunchDarkly';

export const useIsChatAppEnabled = () => {
  const isSierraEnabled = useFeatureFlag('permanent-sierra-enabled');

  return isSierraEnabled;
};
